//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import { AUcallout } from '@gov.au/callout';
import AUbutton from '@gov.au/buttons';
import { useDispatch, useSelector } from "react-redux";

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import Heading from '../components/CASA/Heading';
import ProfileIndividual from '../components/Portal/ProfileIndividual';
import SubModule from '../components/Portal/SubModule';
import Module from '../components/Portal/Module';
import Container from '../components/CASA/Container';

//Actions and Selectors
import { getAppsIndividual, FETCH_APPSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AppsIndividualActions';
import { getLicencesIndividual, FETCH_LICENCESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/LicencesIndividualActions';
import { getREOCsIndividual, FETCH_REOCSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/REOCsIndividualActions';
import { getDronesIndividual, FETCH_DRONESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/DronesIndividualActions';
import { getAircraftTOOIndividual, FETCH_AIRCRAFTTOOINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AircraftTOOIndividualActions';
import { getAircraftIndividual, FETCH_AIRCRAFTINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/AircraftIndividualActions';
import { getDraftFormsIndividual } from '../PortalStore/Actions/DraftFormsIndividualActions';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getUserHomePage, UserMustSubmitIndividualARNApplication, UserMustVerifyPOI } from '../components/Portal/Utilities';

import { getExpirySelector, getFeatureSelector, getUrlSelector, getSnippetSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getUserDetailsSelector } from '../PortalStore/Selectors/UserDetailsSelectors';

export const ProfileIndPage = () => {
    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");
    const [slowLoadDone, setSlowLoadDone] = useState(false);

    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let userdetails = useSelector(state => state.userdetails);
    let envdata = useSelector(state => state.envdata);
    let extids = useSelector(state => state.extid);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);

    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let licencesIndividual = useSelector(state => state.licencesIndividual);
    let appsIndividual = useSelector(state => state.appsIndividual);
    let alertsIndividual = useSelector(state => state.alertsIndividual);
    let reocsIndividual = useSelector(state => state.reocsIndividual);
    let dronesIndividual = useSelector(state => state.dronesIndividual);
    let aircraftIndividual = useSelector(state => state.aircraftIndividual);
    let aircraftTOOIndividual = useSelector(state => state.aircraftTOOIndividual);

    let expiryLic = useSelector(state => getExpirySelector(state, "Portal - Licence expiry warning period"));
    let daysRPAexpiring = useSelector(state => getExpirySelector(state, "Portal - RPA registration expiry warning period"));
    let daysRPAexpired = useSelector(state => getExpirySelector(state, "Portal - RPA registration expired warning period"));
    let expirySavedApp = useSelector(state => getExpirySelector(state, "Portal - Saved Application expiry warning period"));
    let expiryCert = useSelector(state => getExpirySelector(state, "Portal - Certificate expiry warning period"));

    let featureDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Drone"));
    let featureRecDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Recreational Drone"));
    let featureAccred = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Accreditation"));
    let featureAccredRec = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Accreditation (Recreational)"));
    let featureAvWorx = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - AvWorx"));
    let featureOrgARN = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Org ARN"));
    let featureAROC = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - AROC"));
    let featureIndRepl = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Ind REPL"));
    let featureFRN = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - FRN"));
    let featureLicVer = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Licence Verification"));

    let urlFRN = useSelector(state => getUrlSelector(state, "Portal - AEM FRN URL"));
    let urlELP = useSelector(state => getUrlSelector(state, "Portal - AEM ELP URL"));
    let urlAEM = useSelector(state => getUrlSelector(state, "Portal - AEM URL"));
    let urlAROC = useSelector(state => getUrlSelector(state, "Portal - AEM AROC URL"));
    let urlOrgARN = useSelector(state => getUrlSelector(state, "Portal - AEM Organisation ARN URL"));
    let urlFTM = useSelector(state => getUrlSelector(state, "Portal - Flight Test Management URL"));
    let urlAVWORX = useSelector(state => getUrlSelector(state, "Portal - LMS - URL"));
    let urlFCLApply = useSelector(state => getUrlSelector(state, "Portal - AEM Flight Crew Licence Application URL"));

    let urlASF = useSelector(state => getUrlSelector(state, "Portal - ASF Base URL"));
    let urlPaymentRequest = useSelector(state => getUrlSelector(state, "Portal - ASF Payment Request URL"));

    let snippetFCL = useSelector(state => getSnippetSelector(state, "CASA - Flight crew licence application"));

    let fullname = useSelector(state => getUserDetailsSelector(state, "fullname"));
    let arn = useSelector(state => getUserDetailsSelector(state, "casa_arn"));
    let birthdate = useSelector(state => getUserDetailsSelector(state, "birthdate"));
    let email = useSelector(state => getUserDetailsSelector(state, "emailaddress1"));

    let REOCsIndividual = useSelector(state => state.REOCsIndividual);
    let REPLsIndividual = useSelector(state => state.REPLsIndividual);

    let pageAlert = useSelector(state => state.pageAlert);

    const organisationId = "";

    if (!pageLoaded && pageAlert.level !== "") {
        dispatch(addPageAlert({ level: "", title: "", message: "" }));
    }

    useEffect(() => {
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;
        const webappurlF = B2CSettings.items.webappurlFormsApi;
        const droneTypes = featureRecDrone ? ['recreational', 'commercial'] : ['commercial'];
        setPageLoading(true);

        axios.all([
            dispatch(getAppsIndividual(webappurl, accessToken)),
            dispatch(getLicencesIndividual(webappurl, accessToken)),
            dispatch(getREOCsIndividual(webappurlF, accessToken)),
            dispatch(getDronesIndividual(webappurlF, accessToken, droneTypes)), 
            dispatch(getAircraftIndividual(webappurlF, accessToken)),
            dispatch(getAircraftTOOIndividual(webappurl, accessToken))
        ])
            .then(axios.spread((appsres, licsres, reocsres, dronesres, aircraftres, aircrafttoores) => {
                if (appsres.type === FETCH_APPSINDIVIDUAL_SUCCESS
                    && licsres.type === FETCH_LICENCESINDIVIDUAL_SUCCESS
                    && reocsres.type === FETCH_REOCSINDIVIDUAL_SUCCESS
                    && dronesres.type === FETCH_DRONESINDIVIDUAL_SUCCESS
                    && aircraftres.type === FETCH_AIRCRAFTINDIVIDUAL_SUCCESS
                    && aircrafttoores.type === FETCH_AIRCRAFTTOOINDIVIDUAL_SUCCESS
                ) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    //debugger;
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("PI.1");
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: PI.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                //debugger;
                setPageLoadedError(true);
                setPageLoadedErrorMessage("PI.2");
                setPageLoading(false);
                setPageLoaded(true);

                dispatch(addPageAlert({ level: "error", title: "System error PI.2" }));
            });
    }, []);

    const msgexists = (item, index, arr) => {
        return item.msg.message === this.message && item.msg.level === this.level;
    }

    const chkLicenceExpiry = () => {
        //refactor expiry checking to individual modules?
        var indLicences = licencesIndividual.items;
        var tomorrow;
        var warning;
        var activeto;

        // check licences expiring for this individual
        tomorrow = moment().add(1, 'days');
        var expiryLic = moment().add(expiryLic, 'days');
        warning = false;

        var messagesLic = [];
        if (indLicences.value) {
            for (var l = 0; l < indLicences.value.length; l++) {
                if (indLicences.value[l].validUntil && indLicences.value[l].validUntil !== "") {
                    warning = false;
                    activeto = moment(indLicences.value[l].validUntil);
                    if (expiryLic > activeto && activeto > tomorrow) {
                        warning = true;
                    }

                    indLicences.value[l].expiryWarning = warning;
                }
            }

            var msg = "";
            if (indLicences.value.find(item => item.expiry_warning) > -1) {
                msg = { "message": "Items expiring soon", "level": "warning" };
                if (!messagesLic.some(msgexists, msg)) {
                    messagesLic.push({ 'msg': msg });
                }
            }
        }

        return messagesLic;
    }

    const ARNPending = () => {

        var SRARNPending = parseInt(sessionStorage.getItem("casa.indarnsCount")) > 0;  //New or InProgress SR for these forms: Form 1162 - ARN - Individual,Form 1162B - Link ARN,Form 1162A - 100 Point check
        var ARNPending = parseInt(sessionStorage.getItem("casa.draftsCount")) > 0; //Draft AEM Apps for these forms: Form 1162 - ARN - Individual,Form 1162B - Link ARN,Form 1162A - 100 Point check

        return (ARNPending || SRARNPending);
    }

    const PaymentRequest = () => {

        var paymentSubs = 0; //{{ orgsubs_PaymentRequired.size }};

        if (paymentSubs === 0) {
            return null;
        }

        var linkPayment = urlASF + urlPaymentRequest;
        return (
            <div className="casa-dashboard-row row">
                <AUcallout title="">
                    <h3>Payment required</h3>
                    <br />
                    <p>After review and assessment of your recently submitted application/s, you have items requiring payment.</p>
                    <br />
                    <br />
                    <AUbutton link={linkPayment}>
                        Review payment details
                    </AUbutton>
                </AUcallout>
            </div>
        );
    }

    //for accreditation visibility
    var applyExcAccred = false;
    var applyRecAccred = false;
    var showRepl = false;
    var showExcAccred = false;
    var showRecAccred = false;
    var showEcn = false;
    var statusRepl = "nil";
    var statusExcAccred = "nil";
    var statusRecAccred = "nil";

    function setAccredVisibility() {

        //{% for indLic in indlicences %}
        //{% assign category = indLic["cattype.casa_name"] | downcase %}
        //{% assign type = indLic["lictype.casa_name"] | downcase %}
        //{% assign eapstatus = indLic.casa_eapstatus | downcase %}

        //{% if (category == "other" and type == "repl") %}
        //statusRepl = "{{eapstatus}}";
        //{% endif %}
        //{% if (category == "rpa accreditation" and type == "rpa excluded accreditation") %}
        //statusExcAccred = "{{eapstatus}}";
        //{% endif %}
        //{% if (category == "rpa accreditation" and type == "rpa recreational accreditation") %}
        //statusRecAccred = "{{eapstatus}}";
        //{% endif %}
        //{% endfor %}

        //NOTE: recAccred not handled ATM

        //see D20/331189 for details
        switch (statusRepl) {

            case "nil":
            case "inactive":
                switch (statusExcAccred) {

                    case "nil":
                    case "inactive":
                        applyExcAccred = true;
                        break;

                    case "active":
                        showExcAccred = true;
                        break;

                    case "stayed suspension":
                    case "stayed cancellation":
                    case "suspended":
                    case "cancelled":
                    case "suspended at holder's request":
                        showExcAccred = true;
                        break;

                    case "cancelled at holder's request":
                        showExcAccred = true;
                        applyExcAccred = true;
                        break;

                    default:
                        break;
                }
                break;

            case "active":
                showRepl = true;
                break;

            case "stayed suspension":
            case "stayed cancellation":
            case "suspended":
            case "cancelled":
            case "suspended at holder's request":
                switch (statusExcAccred) {
                    case "nil":
                    case "inactive":
                        showRepl = true;
                        break;

                    default:
                        break;
                }
                break;

            case "cancelled at holder's request":
                switch (statusExcAccred) {
                    case "nil":
                    case "inactive":
                        showRepl = true;
                        applyExcAccred = true;
                        break;

                    default:
                        break;
                }
                break;

            default:
                break;
        }

    }

    const DronesAndRPA = () => {

        /* Visibility rule */

        //if (ARNPending()) {
        //    return null;
        //}

        let showDrone = true;
        let showAccred = true;

        /* drones feature is enabled */
        let availDate = moment(featureDrone, "DD/MM/YYYY");
        let available = availDate.isBefore();
        if (!available) showDrone = false;

        /* Visibility Rule */

        /* Over 16 */
        let dob = moment(birthdate); //todo: handle blank?
        let ageyears = moment().diff(dob, 'years');

        if (ageyears < 16) {
            showDrone = false;
            showAccred = false;
        }

        /* accred availability */
        if (!(showRecAccred || showExcAccred || applyRecAccred || applyExcAccred)) {
            showAccred = false;
        }

        /* accred feature is enabled */
        //let availDate = moment(sessionStorage.getItem("casa.g_ACCRED_AVAILABILITY"), "DD/MM/YYYY");
        //let available = availDate.isBefore();
        //if (!available) showAccred = false;

        if (showAccred || showDrone) {

            return (

                <Module name="Drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>">

                    {Accreditation()}

                    {RPA()}

                </Module>
            )
        }
    }

    const RPA = () => {
        /* Visibility Rule */

        /* Over 16 */
        let dob = moment(birthdate); //todo: handle blank?
        let ageyears = moment().diff(dob, 'years');

        if (ageyears < 16) {
            return null;
        }

        /* drones feature is enabled */
        let availDate = moment(featureDrone, "DD/MM/YYYY");
        let available = availDate.isBefore();
        if (!available) {
            return null;
        }

        let jparams = {
            from: "ind",
            organisationId: organisationId
        }
        let linkrpa = "/indmanagerpa?standalone=" + B2CSettings.items.standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));

        let indDrones = dronesIndividual.items;
        let indDronesCount = dronesIndividual.items.value ? dronesIndividual.items.value.length : 0;

        let count = 0;
        let messagesDrone = [];

        let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
        let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');
        var todayStart = moment().startOf('day');

        if (indDrones.value && indDrones.value.length > 0) {
            // check drones expiring for this individual
            let warning = false;
            for (var i = 0; i < indDronesCount; i++) {
                let validUntilEnd = moment(indDrones.value[i]["casa_validuntil"], "YYYY-MM-DD").endOf('day');
                let validUntilStart = moment(indDrones.value[i]["casa_validuntil"], "YYYY-MM-DD").startOf('day');

                if (validUntilEnd < todayStart && expiredRPA < validUntilStart) {
                    // expired
                    warning = true;
                }
                if (expiringRPA > validUntilStart && validUntilStart >= todayStart) {
                    // expiring
                    warning = true;
                    count++;
                }
                if (validUntilStart >= todayStart && validUntilStart > expiringRPA) {
                    count++;
                }
                
                indDrones.value[i].expiryWarning = warning;
            }

            if (indDrones.value.findIndex(item => item.expiryWarning) !== -1) {
                let msg = { "message": "Items expiring soon", "level": "warning" };
                if (!messagesDrone.some(msgexists, msg)) {
                    messagesDrone.push({ 'msg': msg });
                }
            }
        }

        let name = "Drone registration";
        let description1;
        if (count > 0) {
            name = "Manage registered drones";
            if (count === 1) {
                description1 = { 'message': "1 registered drone and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>", 'level': '', 'msgs': [] };
            }
            else {
                description1 = { 'message': count + " registered drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>", 'level': '', 'msgs': [] };
            }
        }
        else {
            description1 = { 'message': "Register your drones (<abbr title='Remotely Piloted Aircraft'>RPA</abbr>)", 'level': '', 'msgs': [] };
        }

        let dronesinprog = appsIndividual && appsIndividual.items && appsIndividual.items.inprogdrones && appsIndividual.items.inprogdrones.length > 0;

        if (count > 0 && dronesinprog) {
            description1 = { 'message': description1.message + "<br/>1 or more in-progress registered drones and <abbr title='Remotely Piloted Aircraft'>RPA</abbr>", 'level': '', 'msgs': messagesDrone };
        }

        if (count === 0 && !dronesinprog) {
            description1 = { 'message': "Register your drones (<abbr title='Remotely Piloted Aircraft'>RPA</abbr>)", 'level': '', 'msgs': [] };
        }

        return (
            <SubModule
                name={name}
                link={linkrpa}
                description1={description1}
                messages={messagesDrone} />
        )

    }

    const Accreditation = () => {
        /* Visibility Rule */

        /* hide if has repl */
        var indLicences = licencesIndividual.items;
        if (indLicences !== null && indLicences.value.length > 0 && indLicences.value[0]["cattype.casa_name"].toLowerCase() === "other" && indLicences.value[0]["lictype.casa_name"].toLowerCase() === "repl") {
            return null;
        }

        ///* Over 16 */

        //var dob = moment(this.birthdate);
        //var ageyears = moment().diff(dob, 'years');
        //if (ageyears < 16) {
        //    return;
        //}

        /* turn off accred */
        //if (!FeatureAvailable(this.featureAccred))
        //        return null;

        //let commAccredDate = moment(featureAccred, "DD/MM/YYYY");
        //let commAvailable = commAccredDate.isBefore();

        var link = '/drone-accreditation';
        var name = "Drone accreditation";
        var description = "Get drone accreditation and become an accredited drone operator";

        if (indLicences !== null && indLicences.value.length > 0) {
            if (indLicences.value[0]["cattype.casa_name"].toLowerCase() === "rpa accreditation" && indLicences.value[0]["lictype.casa_name"].toLowerCase() === "rpa excluded accreditation") {
                description = 'View commercial drone accreditation'
                link = "/showcommaccred?licid=" + indLicences.value[0].casa_licenceid + "&applyExcAccred=" + applyExcAccred;
            }
            else if (indLicences.value[0]["cattype.casa_name"].toLowerCase() === "rpa accreditation" && indLicences.value[0]["lictype.casa_name"].toLowerCase() === "rpa recreational accreditation") {
                description = 'View recreational drone accreditation'
                link = "/showrecaccred?licid=" + indLicences.value[0].casa_licenceid;
            }
        }

        var messagesLic = chkLicenceExpiry();

        var message = { 'message': description, 'level': '', 'msgs': messagesLic };

        return (
            <SubModule
                name={name}
                link={link}
                description1={message} />
        )

    }

    const ApplicationSummary = () => {

        //debugger;

        /* Visibility Rule */

        let linkapps = "/appsind";

        let toocount = 0;
        let tooinactiveaccount = 0;
        if (aircraftTOOIndividual.items?.value && aircraftTOOIndividual.items?.value.length > 0) {
            let subids = [];
            for (let i = 0; i < aircraftTOOIndividual.items.value.length; i++) {
                let a = aircraftTOOIndividual.value.items.value[i];
                if (subids.indexOf(a["sub.casa_submissionid"]) === -1) {
                    subids.push(a["sub.casa_submissionid"]);

                    if ((a.statuscode === 2 && a["sub.statecode"] === 1) || (a["srvcatjob.casa_code"] === 'ACR_TOO_ACC' && a.statuscode === 2)) {
                        tooinactiveaccount++;
                    }
                    else {
                        if ((a["sub.statecode"] === 0 && a["srvcatjob.casa_code"] !== 'ACR_TOO_ACC') || (a["sub.statecode"] === 0 && a["srvcatjob.casa_code"] === 'ACR_TOO_ACC' && a.statuscode !== 2)) {
                            toocount++;
                        }
                    }
                }
            }
        }

        let messagesApp = [];

        let savedFormsAppsArr = [];
        let savedAEMAppsArr = []; //TODO
        if (savedAEMAppsArr.length > 0) {
            let msg = { "message": "In Progress", "level": "success" };
            if (!messagesApp.some(this.msgexists, msg)) {
                messagesApp.push({ 'msg': msg });
            }
        }

        //if (this.draftFormsIndividual.items.length > 0) {
        //    savedFormsAppsArr = this.draftFormsIndividual.items;
        //    if (savedFormsAppsArr.length > 0) {
        //        msg = { "message": "In Progress", "level": "success" };
        //        if (!messagesApp.some(this.msgexists, msg)) {
        //            messagesApp.push({ 'msg': msg });
        //        }
        //    }
        //}

        // check expiry
        let daysApp = expirySavedApp.casa_stringvalue;
        let expiryApp = moment().add(daysApp, 'days');

        //only for AEM
        for (let i = 0; i < savedAEMAppsArr.length; i++) {
            let activeto = moment(savedAEMAppsArr[i].lastModified, 'DD/MM/YYYY').add(7, 'days');
            if (activeto.isSame(expiryApp, 'day')) {
                let msg = { "message": "Items expiring soon", "level": "warning" };
                if (!messagesApp.some(this.msgexists, msg)) {
                    messagesApp.push({ 'msg': msg });
                }
            }
        }

        let description2 = "";
        let inprogs = appsIndividual.items.srsactive.length + appsIndividual.items.subsactive.length + toocount;
        if (inprogs > 0) {
            if (inprogs === 1) {
                description2 = "1 in-progress application";
            }
            else {
                description2 = inprogs + " in-progress applications";
            }
        }

        let description3 = "";
        let savedCount = savedAEMAppsArr.length + savedFormsAppsArr.length;
        if (savedCount.length > 0) {
            if (savedCount === 1) {
                description3 = "1 saved application";
            }
            if (savedCount > 1) {
                description3 = savedCount + " saved applications";
            }
        }

        let description1 = "";
        let comps = appsIndividual.items.srsinactive.length + appsIndividual.items.subsinactive.length + tooinactiveaccount;
        if (comps > 0) {
            if (comps === 1) {
                description1 = "1 completed application";
            }
            else {
                description1 = comps + " completed applications";
            }
        }

        let message1 = { 'message': description1, 'level': '', 'msgs': [] };
        let message2 = { 'message': description2, 'level': '', 'msgs': messagesApp };
        let message3 = { 'message': description3, 'level': '', 'msgs': [] };

        //testing only

        return (

            <Module name="Application Summary">

                <SubModule
                    name="View Application Summary"
                    link={linkapps}
                    description1={message1}
                    description2={message2}
                    description3={message3}
                />

                <button onClick={openSavedDraft}
                >Open draft</button>

            </Module>
        )

    }

    const openSavedDraft = () => {
        

        var params = {};

        
        //FORMS
        let asfBaseUrl = sessionStorage.getItem("casa.g_ASF_BASE_URL");
        params.recordid = '76fd31e9-54e8-41d9-bc86-119d873ac9b6';
            
        let form = 'dronesrenewind';
        location.assign("/" + form + "?params=" + encodeURIComponent(btoa(JSON.stringify(params))));
    };

    const Aircraft = () => {

        /* Visibility Rule */
        //if (this.ARNPending()) {
        //    return null;
        //}

        if (!(aircraftIndividual.items?.aircraft?.value && aircraftIndividual.items?.gliders?.value)) {
            return null;
        }

        let tomorrow = moment().add(1, 'days');
        let today = moment().startOf('day');
        let planes = 0;
        let gliders = 0;

        for (let a=0; a<aircraftIndividual.items.aircraft.value.length; a++) {
            let aircraft = aircraftIndividual.items.aircraft.value[a];
            let activeto = moment(aircraft["participant.casa_validuntil"],"YYYY-MM-DD").startOf('day');
            let activefrom = moment(aircraft["participant.casa_validfrom"], "YYYY-MM-DD").startOf('day');

            if ((activeto.isValid() === false || activeto > today)
                && (activefrom.isValid() === false || activefrom < tomorrow)) {
                planes++;
            }
        }

        for (let g = 0; g < aircraftIndividual.items.gliders.value.length; g++) {
            let glider = aircraftIndividual.items.gliders.value[g];
            let activeto = moment(glider["participant.casa_validuntil"], "YYYY-MM-DD").startOf('day');
            let activefrom = moment(glider["participant.casa_validfrom"], "YYYY-MM-DD").startOf('day');

            if ((activeto.isValid() === false || activeto > today)
                && (activefrom.isValid() === false || activefrom < tomorrow)) {
                gliders++;
            }
        }

        //don't show if no aircraft
        if (planes + gliders === 0) {
            return null;
        }

        let message = "";
        if (planes + gliders > 0) {
            message = (planes + gliders) + " registered aircraft";
        }

        //add acr check
        let msgs = [];
        let msg = {};
        if (planes > 0 && appsIndividual.items.census && appsIndividual.items.census.length === 0) {
            msg = { "message": "Items for review", "level": "warning" };
            msgs.push({ 'msg': msg });
        }

        let description1 = { 'message': message, 'level': '', 'msgs': [] };

        let jparams = {
            from: "ind"
        }
        let linkaircraft = "/manageaircraftind?standalone=" + B2CSettings.items.standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));

        return (
            <Module name="Aircraft">

                <SubModule
                    name="Manage aircraft"
                    link={linkaircraft}
                    messages={msgs}
                    description1={description1} />

            </Module>
        )
    }

    const OrgsAndBusinesses = () => {

        /* Visibility Rule */
        if (this.ARNPending()) {
            return null;
        }

        /* turn off org arn */
        var availDate = moment(this.featureOrgARN, "DD/MM/YYYY");
        var available = availDate.isBefore();
        if (!available) return;

        var crumbs = [
            {
                link: '/forms/dashind?standalone=' + B2CSettings.items.standalone,
                text: 'myCASA'
            }
        ];

        var params = {
            'breadcrumbs': crumbs
        };

        //use selectors
        var linkapplyorg = this.urlAEM + this.urlOrgARN + encodeURIComponent(btoa(JSON.stringify(params)));

        var messages = [];

        var orgname = "Organisation aviation reference number (<abbr title='Aviation reference number'>ARN</abbr>)</a>";

        var message1 = { 'message': "Apply for a link to an existing organisation reference number", 'level': '', 'msgs': [] };

        return (
            <Module name="Organisations and businesses">

                <SubModule
                    name={orgname}
                    link={linkapplyorg}
                    messages={messages}
                    description1={message1} />

            </Module>
        )
    }

    const REOC = () => {
        //shows REOCS

        /* Visibility Rule */

        //if (this.ARNPending()) {
        //    return null;
        //}

        ///* Has REOC */
        var indCertificates = this.certificatesIndividual.items;
        if (indCertificates.length === 0) {
            return null;
        }

        var certInd = indCertificates[0];
        // check certificate[0] expiring for this individual
        //use selector
        var daysCert = this.expiryCert.casa_stringvalue;
        var expiryCert = moment().add(daysCert, 'days');
        var tomorrow = moment().add(1, 'days');
        var warning = false;
        var activeto = moment(certInd.casa_activeto);
        if (expiryCert > activeto && activeto > tomorrow) {
            warning = true;
        }

        indCertificates.value[0] = {
            'role': certInd["role.casa_name"],
            'casa_name': certInd["casa_name"],
            'expiry_warning': warning,
            'id': certInd["casa_certificateid"],
            'hasTraining': certInd["casa_hasrepltraining"]
        };
        indCertificates.value[0].casa_validuntil = moment(certInd.casa_activeto).format('DD MMM YYYY');

        var messagesCert = [];
        if (indCertificates.value.find(item => item.expiry_warning) > -1) {
            var msg = { "message": "Items expiring soon", "level": "warning" };
            if (!messagesCert.some(this.msgexists, msg)) {
                messagesCert.push({ 'msg': msg });
            }
        }

        var linkreoc = "/ReOCDetails?from=ind&reocid=" + indCertificates.value[0].id;
        var name = "Remotely piloted aircraft operator's certificate (ReOC)";
        var expiry = "Expiry Date: " + indCertificates.value[0].casa_validuntil;

        var message1 = { 'message': expiry, 'level': '', 'msgs': messagesCert };

        return (

            <Module name={name}>

                <SubModule
                    name={indCertificates.value[0].casa_name}
                    link={linkreoc}
                    messages={messagesCert}
                    description1={message1} />

            </Module>
        )
    }

    const FlightCrewLicencingServices = () => {

        //if (this.ARNPending()) {
        //    return null;
        //}

        //if (this.state.LicsAndAuths === null ||
        //    !(this.state.LicsAndAuths.flightreviewnotification || this.state.LicsAndAuths.flighttestmanagement ||
        //    this.state.LicsAndAuths.elpnotification || this.state.LicsAndAuths.arocapplication)) {
        //    return null;
        //}

        return (
            <Module name="Flight crew licencing services">

                {this.FlightTestManagement()}

                {this.FlightRenewNotification()}

                {this.ELP()}

                {this.AROCApplication()}

            </Module>
        )
    }

    const FlightTestManagement = () => {

        /* Visibility Rule */
        //if (this.state.LicsAndAuths === null || !this.state.LicsAndAuths.flighttestmanagement) {
        //    return null;
        //}

        var ftmLink = this.urlFTM;

        var message1 = { 'message': "Access flight test management for flight test notifications", 'level': '', 'msgs': [] };

        return (

            <SubModule
                name="Flight test management"
                link={ftmLink}
                extLink={true}
                description1={message1} />
        )
    }

    const FlightRenewNotification = () => {

        /* Visibility Rule */

        //if (this.state.LicsAndAuths === null || !this.state.LicsAndAuths.flighttestmanagement) {
        //    return null;
        //}

        //var availDate = moment(this.featureFRN, "DD/MM/YYYY");
        //var available = availDate.isBefore();
        //if (!available) return;

        var crumbs = [
            {
                link: '/forms/dashind?standalone=' + B2CSettings.items.standalone,
                text: 'myCASA'
            }
        ];

        var params = {
            'breadcrumbs': crumbs
        };

        var frnform = this.urlAEM + this.urlFRN + "?params=" + encodeURIComponent(btoa(JSON.stringify(params)));

        var message1 = { 'message': "Notify CASA of a flight review", 'level': '', 'msgs': [] };

        return (

            <SubModule
                name="Flight review notification"
                link={frnform}
                description1={message1} />

        )
    }

    const ELP = () => {

        /* Visibility Rule */

        //if (this.state.LicsAndAuths === null || !this.state.LicsAndAuths.elpnotification) {
        //    return null;
        //}

        //var availDate = moment(this.featureELP, "DD/MM/YYYY");
        //var available = availDate.isBefore();
        //if (!available) return;

        var crumbs = [
            {
                link: '/forms/dashind?standalone=' + B2CSettings.items.standalone,
                text: 'myCASA'
            }
        ];

        var params = {
            'breadcrumbs': crumbs
        };

        var elpform = this.urlAEM + this.urlELP + "?params=" + encodeURIComponent(btoa(JSON.stringify(params))); //?

        var message1 = { 'message': "Notify CASA of an English language proficiency assessment", 'level': '', 'msgs': [] };

        return (

            <SubModule
                name="English language proficiency (ELP) notification"
                link={elpform}
                description1={message1} />

        )
    }

    const AROCApplication = () => {

        /* Visibility Rule */

        //if (this.state.LicsAndAuths == null || !this.state.LicsAndAuths.arocapplication) {
        //    return null;
        //}

        //var availDate = moment(this.featureAROC, "DD/MM/YYYY");
        //var available = availDate.isBefore();
        //if (!available) return;

        var crumbs = [
            {
                link: '/forms/dashind?standalone=' + B2CSettings.items.standalone,
                text: 'myCASA'
            }
        ];

        var params = {
            'breadcrumbs': crumbs
        };

        var arocform = this.urlAEM + this.urlAROC + "?params=" + encodeURIComponent(btoa(JSON.stringify(params)));

        var message1 = { 'message': "Submit application for an aeronautical radio operator's certificate", 'level': '', 'msgs': [] };

        return (

            <SubModule
                name="Aeronautical radio operator's certificate (AROC) application"
                link={arocform}
                description1={message1} />

        )
    }

    const LicencesAndAuthorisations = () => {
        // shows FCL, AROC and REPL

        /* Visibility Rule*/
        //if (this.ARNPending()) {
        //    return null;
        //}

        //var indLicences = licencesIndividual.items.value;
        //if ((this.state.LicsAndAuths !== null && this.state.LicsAndAuths.flightcrewlicence) ||
        //    (indLicences.length > 0 && indLicences[0].category.toLowerCase() === "other" && indLicences[0].type.toLowerCase() === "repl") ||
        //    (this.state.LicsAndAuths !== null && this.state.LicsAndAuths.aroc)) {
        //if (indLicences !== null &&
        //    (indLicences.length > 0 && indLicences[0].category.toLowerCase() === "other" && indLicences[0].type.toLowerCase() === "repl") ) {

        //if ((LicsAndAuths != null && LicsAndAuths.flightcrewlicence) ||
        //    (showRepl) ||
        //    (LicsAndAuths != null && LicsAndAuths.aroc)) {

        return (
            <Module name="Licences and authorisations">


                { Licences() }

                { FlightCrewLicence()}

            </Module>
        );
        
        //{this.AROC()}

        //}
        //else {
        //    if (!FeatureAvailable(this.featureLicVer))
        //        return null;

        //    return (
        //        <Module name="Licences and authorisations">

        //            {this.LicenceVerification()}

        //        </Module>
        //    );
        //}
    }

    const FlightCrewLicence = () => {

        /* Visibility Rule*/
        //if (this.state.LicsAndAuths == null || !this.state.LicsAndAuths.flightcrewlicence) {
        //    return null;
        //}

        var name = "Flight crew licence";

        var linkfcl = "/licence-view-multiple";


        //not needed banshee 2
        //var msg;
        //var messagesLic = [];
        //if (this.state.LicsAndAuths.flightcrewlicencecomponents != null) {
        //    for (var i = 0; i < this.state.LicsAndAuths.flightcrewlicencecomponents.length; i++) {
        //        if (this.state.LicsAndAuths.flightcrewlicencecomponents[i].componentStatus === "Active") {
        //            msg = { "message": this.state.LicsAndAuths.flightcrewlicencecomponents[i].name + " - " + this.state.this.state.LicsAndAuths.flightcrewlicencecomponents[i].category, msg: {} };
        //        }
        //        else {
        //            msg = { "message": this.state.LicsAndAuths.flightcrewlicencecomponents[i].name + " - " + this.state.LicsAndAuths.flightcrewlicencecomponents[i].category, msg: { "message": "Suspended", "level": "error" } };

        //        }
        //        messagesLic.push({ 'msg': msg });
        //    }
        //}

        return (
            <SubModule
                name={name}
                link={linkfcl}
            />
        )

    }

    const Licences = () => {
        //return null;
        //debugger;
        var indLicences = licencesIndividual.items?.value;
        if (!indLicences || indLicences.length === 0) {
            return null;
        }

        /* Visibility Rule */
        /* has a repl */
        //if (!(indLicences.length > 0 && indLicences[0].category.toLowerCase() == "other" && indLicences[0].type.toLowerCase() == "repl")) { 
        //return null;
        //}

        //repl matrix
        //if (!showRepl) {
        //    return null;
        //}

        //var indCertificates = reocsIndividual.items?.value;

        /* Has REOC with training flag */ //not implemented for individual by AEM
        //if (indCertificates.length > 0) {
        //    if (!indCertificates[0].hasTraining) {
        //        return;
        //    }
        //}

        /* has a repl */
        //if (!(indLicences.length > 0 && indLicences[0].category.toLowerCase() === "other" && indLicences[0].type.toLowerCase() === "repl")) {
        //    return null;
        //}

        /* turn off repl */
        //if (!FeatureAvailable(featureIndRepl))
        //    return null;

        var name = "Remote pilot licence (RePL)";
        var linkrepl = "/showreplaccred";

        var badge = null;// { "msg": { "message": "", "level": "" } };
        //if (indLicences.length > 0 && indLicences[0].casa_eapstatus.toLowerCase() !== "active") {
        //    badge = { "msg": { "message": "Suspended", "level": "error" } };
        //}
        //debugger;
        var msgs = [];
        //var msg = { "message": '', msg: { "message": "", "level": "" } };
        //msgs.push({ 'msg': msg });
        //var msg;
        //for (var i = 0; i < indLicences.length; i++) {
        //    msg = { "message": indLicences[i].comp_name, msg: { "message": "", "level": "" } };
        //    msgs.push({ 'msg': msg });
        //}

        return (
            <SubModule
                name={name}
                link={linkrepl}
                messages={msgs}
                badge={badge} />
        )

    }

    const AROC = () => {

        /* Visibility Rule */

        if (!this.state.LicsAndAuths || !this.state.LicsAndAuths.aroc) {
            return null;
        }

        return (
            <div className="casa-dashboard-item col-lg-6 col-md-6 col-xs-12" >

                <h3 className="au-display-sm">
                    Aeronautical radio operator&pos;s certificate (AROC)
                </h3>
                <div>
                    <span>{"Date of issue: " + moment(this.state.LicsAndAuths.arocissuedate).format("DD MMM YYYY")}</span>
                </div>
            </div>
        )

    }

    const TrainingAndLearning = () => {

        /* Visibility Rule */

        //if (this.ARNPending()) {
        //     return null;
        //}

        return (
            <Fragment>
                <Module name="Training and learning">

                    {AviationWorx()}

                </Module>
            </Fragment>
        )

    }

    const AviationWorx = () => {

        /* Visibility Rule */

        //if (this.ARNPending()) {
        //    return null;
        //}

        /* turn off avworx */
        var availDate = moment(featureAvWorx, "DD/MM/YYYY");
        var available = availDate.isBefore();
        if (!available) return;

        var name = "AviationWorx";
        var description = "Access CASA seminars, events and eLearning";

        var linkaviationworx = urlAVWORX;

        var message1 = { 'message': description, 'level': '', 'msgs': [] };

        return (
            <SubModule
                name={name}
                link={linkaviationworx}
                description1={message1}
            />
        )

    }

    const FlightCrewLicenceApplication = () => {

        //Visibility rules

       

        let msg = this.snippetFCL;

        var crumbs = [
            {
                link: '/forms/dashind?standalone=' + B2CSettings.items.standalone,
                text: 'myCASA'
            }
        ];

        var params = {
            'breadcrumbs': crumbs
        };

        var fclform = this.urlAEM + this.urlFCLApply + "?params=" + encodeURIComponent(btoa(JSON.stringify(params)));

        return (
            <div className="casa-dashboard-row row">
                <AUcallout title="">
                    <span dangerouslySetInnerHTML={{ __html: msg }} />
                    <AUbutton link={fclform}>
                        Review licence application details
                    </AUbutton>
                </AUcallout>
            </div>
        );
    }

    const showSpinner = () => {
        if (!pageLoadedError) {
            return (<CASASpinner message="Working. Please wait....." />)
        }
        else {
            return null;
        }
    }

    const SlowLoaderFormDrafts = (step) => {

        return null;
        //Get Form drafts
        if (this.state.slowloaddone >= step) {
            return null;
        }

        //todo:
        //ANS details
        //flight crew ratings
        //delegated instruments
        //fcl (exam/components)

        //show minispinner with changing msg in slow loader

        var username = this.emailaddress1;

        var tokenRequestForms = {
            scopes: [this.B2CSettings.items.ScopesForms],
            loginHint: username
        }
        var webappurlFormsApi = this.B2CSettings.items.webappurlFormsApi;
        
        this.ClientApp.items.acquireTokenSilent(tokenRequestForms)
            .then(tokenResponse => {
                if (tokenResponse.accessToken !== null) {
                    axios.all([
                        this.dispatch(getDraftFormsIndividual(webappurlFormsApi, tokenResponse.accessToken, this.draftFormsIndividual.stale)),
                    ])
                        .then(responseArr => {
                            //debugger;
                            //set state
                            this.setState({ slowloaddone: 1 });
                        })
                        .fail(
                            function (error) {
                                //debugger;
                                //        ReactDOM.render(
                                //            React.createElement(AUpageAlert, {
                                //                as: "error"
                                //            },
                                //                React.createElement("h3", null, "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk."),
                                //                React.createElement("h4", null, "Details: System error (Code:12.2)")
                                //            ), document.getElementById('message'));

                                //        $("#msg").show();

                                //        $("#slowLoader").hide();

                                //        slowloaddone = true;

                                //        CreateDashboard();
                                //    }
                                //);
                            })
                }
                else {
                    //null jwt
                    debugger; //todo return with error msg
                }
            })
            .catch(error => {
                debugger; //todo return with error msg
            });


    }

    const SlowLoaderLicences = (step) => {

        //Get EAP Licences
        if (slowLoadDone) {
            return;
        }

        //todo:
        //ANS details
        //flight crew ratings
        //delegated instruments
        //fcl (exam/components)

        //show minispinner with changing msg in slow loader
        if (slowLoadDone >= step) {
            return;
        }


    }

    let items = [];
    let showItems = false;

    if (pageLoading) {

        return (
            <Fragment>
                <MetaTags>
                    <title>Individual Profile</title>
                </MetaTags>

                <ProfileIndividual arn={arn} name={fullname} hasParticipants={participants.items.hasParticipants} standalone={B2CSettings.items.standalone} />

                <Heading
                    id="dashboardheading"
                    text="Welcome to myCASA"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={false} />

                <Container show={true}>
                    {showSpinner()}
                </Container>


            </Fragment>)

    }
    else {
        if (!pageLoaded) {
            return null;
        }

        // prevent access if user does not have arn or has not applied for one (if called directly by url)
        let userHomePage = getUserHomePage(srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants);

        if (UserMustSubmitIndividualARNApplication(userHomePage) || UserMustVerifyPOI(userHomePage)) {
            history.push(userHomePage);
            return null;
        }

        return (
            <Fragment>
                <MetaTags>
                    <title>Individual Profile</title>
                </MetaTags>

                <ProfileIndividual arn={arn} name={fullname} hasParticipants={participants.items.hasParticipants} standalone={B2CSettings.items.standalone} />

                {/*<div id="unsupported-browser" style="display:none">*/}
                {/*    {{ snippets['CASA - Browser Warning'] }}*/}
                {/*</div>*/}

                
                <Heading
                    id="dashboardheading"
                    text="Welcome to myCASA"
                    breadcrumbs={items}
                    showcrumbs={showItems}
                    showback={false} />

                <Container show={true}>

                    {PaymentRequest()}

                    {Aircraft()}

                    {DronesAndRPA()}

                    {TrainingAndLearning()}

                    {LicencesAndAuthorisations()}

                    {/*{ApplicationSummary()}*/}

                </Container>
            </Fragment>
        );
    }

}
